import styled from "styled-components";
import { getBreakpoints } from "../../assets/store/cssBreakpoints";
const { xs, sm, md, lg, xl, xxl } = getBreakpoints();

export const StyledOverlay = styled.div`
    position: fixed;
    display: flex;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.65);
    justify-content: center;
    align-items: center;
    z-index: 1001;
`;

export const StyledContainer = styled.div`
    &&& {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: center; 
        align-items: center;
        width: 550px;
        height: 150px;
        background-color: #1e1e1e;
        border-radius: 20px;
        
        input[type='text'] {
            height: unset !important;
            margin: unset !important;
        }

        input[type='email'] {
            width: unset !important;
        }

        input[readonly] {
            background-color: black !important;
        }

        @media only screen and (max-width: ${sm}px) {
            height: 200px;
            width: 80%;
        };
    }
`;

export const StyledInput = styled.input`
    &&& {
        padding: 10px 60px 10px 10px;
        width: 100%;
        border-radius: ${(props) => props.borderRadius};
        border: 0.2px rgba(255, 255, 255, 0.25) solid;
        background-color: black;
        color: white;
        box-sizing: border-box;

        @media only screen and (max-width: ${sm}px) {
            font-size: 12px;
        }
    }
`;

export const StyledCopyButton = styled.button`
    &&& {
        position: absolute;
        right: 0px;
        margin-right: 5px;
        border-radius: ${(props) => props.borderRadius};
        border: none;
        padding: 3px 10px;
        cursor: pointer;
        background: white !important; 
    
        @media only screen and (max-width: ${sm}px) {
            font-size: 12px;
            margin-right: calc(10% - 8px);
        };
    }
`;
export const StyledEmailButton = styled.button`
    &&& {
        border-radius: ${(props) => props.borderRadius};
        border: none;
        cursor: pointer;
        background: ${(props) => props.backgroundColor} !important; 
        color: ${(props) => props.color};
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 3px 10px 5px 25px;
        margin-left: 10px;
    
        @media only screen and (max-width: ${sm}px) {
            font-size: 12px;
            margin-right: calc(10% - 8px);
        };

        svg > path{
            fill: ${(props) => props.color};
        }
    }
    
    &&&:hover {
        color:${(props) => props.hoverColor}; 
        background: ${(props) => props.hoverBackgroundColor} !important; 
        
        svg > path{
            fill: ${(props) => props.hoverColor};
        }
    }
`;

export const StyledText = styled.span`
    &&& {
        color: white;
        position: absolute; 
        top: 0; 
        left: 0; 
        padding: 20px; 
        font-size: 15px; 
        font-weight: 100;
    }
`;

export const CloseButton = styled.button`
    &&& {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        right: 0;
        color: white;
        margin: 20px;
        font-size: 15px;
        cursor: pointer;
        background-color: unset;
        border: none;
        transition: color 0.15s ease;
    
        &:hover {
            color: grey;
        }
    }
`;